import styled, { css } from 'styled-components';

import { TextAreaField } from '@/components/TextAreaField';
import { Typography } from '@/components/Typography';

export const CommentTextArea = styled(TextAreaField)`
  ${({ theme }) => css`
    background: ${theme.colors.lightGrey};
  `}
`;

export const Text = styled(Typography)`
  ${({ theme }) => css`
    a {
      color: ${theme.colors.primaryDark};
      font-weight: ${theme.fontWeights.semibold};
    }
  `};
`;
